import { Device } from "@services/devices/types";
import { getIsDevicePaused } from "./getIsDevicePaused";

export const getDeviceLastUpdated = (device: Device | undefined) => {
  let lastUpdated = -1;

  if (device && device.detailedStatuses) {
    for (const status of device.detailedStatuses) {
      const pauseMonitoringStatus = status.pauseMonitoringStatus;
      const date = status.lastUpdated ?? -3;

      const isDevicePaused = getIsDevicePaused(device);

      if (isDevicePaused) {
        const pausedSince = pauseMonitoringStatus?.pausedSince;

        if (pausedSince && pausedSince > lastUpdated) {
          lastUpdated = pausedSince;
        }
      } else if (date > lastUpdated) {
        lastUpdated = date;
      }
    }
  }

  return lastUpdated > 0 ? lastUpdated : undefined;
};
